(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/ms", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/ms"] = factory();
	else
		root["i18n/ms"] = factory();
})(window, function() {
return 